type CoverProps = {
  accent?: string | null;
  eventSlug?: string | null;
  icon?: string | null;
  probability?: number;
  compact?: boolean;
  imageUrl?: string | null;
  fit?: "cover" | "contain" | "portrait" | null;
};

function hueOf(slug: string): number {
  let h = 0;
  for (let i = 0; i < slug.length; i++) h = (h * 33 + slug.charCodeAt(i)) >>> 0;
  return h % 48;
}

export function MarketCover({ accent, eventSlug, icon, probability, compact, imageUrl, fit }: CoverProps) {
  const slug = eventSlug || "market";
  const shift = hueOf(slug);
  const color = accent || "#F97316";
  const photo = Boolean(imageUrl);
  return (
    <div
      className={`mkt-cover${compact ? " compact" : ""}${photo ? " has-photo" : ""}`}
      style={
        photo
          ? { background: "#101a33" }
          : { background: `linear-gradient(145deg, #101a33 0%, #1a2747 42%, ${color} 160%)` }
      }
      aria-hidden
    >
      {imageUrl ? (
        <img
          className={`mkt-cover-img ${fit === "contain" ? "contain" : fit === "portrait" ? "portrait" : "cover"}`}
          src={imageUrl}
          alt=""
        />
      ) : (
        <>
          <span className="mkt-cover-orb" style={{ transform: `translate(${shift % 40}px, ${(shift % 18) - 8}px)` }} />
          <span className="mkt-cover-orb two" style={{ background: color }} />
          <span className="mkt-cover-icon">{icon || "●"}</span>
        </>
      )}
      <span className="mkt-cover-shade" />
      {probability != null && <span className="mkt-cover-prob">{probability}%</span>}
    </div>
  );
}
